import styled from "styled-components"

export const InfoContainer = styled.div`
    margin: 18px 0;
    width: 100%;
    height: 50px;
    background-color: #D5D6E0;

    display: flex;
    align-items: center;
    justify-content: center;
    border: solid 1px;

    p{
        flex: 1;
        font-size: 16px;
        text-align: center;
        margin: 0;
    }
`
